<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'AptModel',
    props:[
        "data",
    ],
    data() {
        return {
            aptList: [],
            form: {},
            submitted: false,
        };
    }, 
    computed:{
        modalTitle(){ return "Apartman Sistemine Ekle" }
    },
    watch:{
        data(props){
            this.form = {...props}
            this.getApt()
        }
    },
    methods: {
        getApt(){
            this.$http.post('/apartman?output=one&fields=apartments.id,apartments.name')
            .then(resp => this.aptList = resp.data)
        },
        handleSubmit(){
            this.$http.put('/members/kb_update', this.form)
            .then(resp => notify.success(resp.data.message))
        },
        close(){
            this.$parent.$bvModal.hide('apt_modal')
        }
    },
};
</script>

<template>
<b-modal id="apt_modal"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md-12">
                 <div class="alert alert-warning">
                    {{ form.fname }}
                    {{ form.lname }}
                    <br>
                    {{ form.username}}
                </div>
            </div>
        </div>  
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
                <label>Apartman Adı</label>
                <v-select
                    label="name" 
                    v-model="form.apartment_id"
                    :options="aptList" 
                    :reduce="data => data.id">
                    <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-3">
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Ata
            </b-button>
        </div>
    </form>
</b-modal>
</template>